"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserListRowEditComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const organizations_service_1 = require("./organizations.service");
const notification_service_1 = require("./notification.service");
//VARIABLE MODELS
const user_1 = require("./user");
const organization_1 = require("./organization");
const permission_1 = require("./permission");
const rxjs_1 = require("rxjs");
let UserListRowEditComponent = class UserListRowEditComponent {
    constructor(_talk, _organization, _elementRef) {
        this._talk = _talk;
        this._organization = _organization;
        this._elementRef = _elementRef;
        this.showOrgs = false;
        this.organizationSearchDelay = 30;
        this.organizationSearchLimit = 10;
    }
    ngOnInit() {
        this.initListeners();
        this.editUser = new user_1.User(Object.assign({}, this.user));
        this.editUser.convertRolesToIds();
        this.roleDropDown = this.roles.map(role => {
            return { id: role.id, name: role.displayName, fa: role.fa };
        });
        this.user.organization.text = this.user.organization.displayName;
        this.organizations = [this.user.organization];
        this.organization = [this.organizations[0]]; // must be an array in order to work for default value ("active")
    }
    initListeners() {
        const eventStream = rxjs_1.Observable.fromEvent(this._elementRef.nativeElement, "keyup")
            .map(() => this.organizationSearchText)
            .debounceTime(this.organizationSearchDelay)
            .distinctUntilChanged();
        eventStream.subscribe((input) => __awaiter(this, void 0, void 0, function* () {
            this.organizations = yield organization_1.Organization.list({
                displayName: input,
                limit: this.organizationSearchLimit,
            });
        }));
    }
    organizationSelected($event) {
        this.editUser.organization = $event.id;
    }
    organizationUnselected($event) {
        delete this.editUser.organization;
    }
    organizationSearchChanged($event) {
        if ($event) {
            this.organizationSearchText = $event;
        }
        else {
            this.organizationSearchText = null;
        }
    }
    toggleShowOrgs() {
        if (!this.organizations.length) {
            this.organizations = this._organization.get();
        }
        this.showOrgs = !this.showOrgs;
    }
    cancel() {
        this.user.editing = false;
    }
    // dont pass this in editUser
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            let validationErrors = this.editUser.validate({ password: false, roles: true });
            if (validationErrors && validationErrors.length) {
                this._talk.broadcast(validationErrors);
                return;
            }
            this.editUser.editing = false;
            try {
                yield this.editUser.update();
                Object.assign(this.user, this.editUser);
                this._talk.broadcast("User Saved Successfully.");
            }
            catch (err) {
                this._talk.broadcast(`Error Saving User: ${err.cause.message}`);
            }
        });
    }
};
exports.UserListRowEditComponent = UserListRowEditComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", user_1.User)
], UserListRowEditComponent.prototype, "user", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", permission_1.Permission)
], UserListRowEditComponent.prototype, "permission", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], UserListRowEditComponent.prototype, "roles", void 0);
exports.UserListRowEditComponent = UserListRowEditComponent = __decorate([
    (0, core_1.Component)({
        selector: "user-list-row-edit",
        templateUrl: "app/user-list-row-edit.component.html",
        styleUrls: ["styles/admin.component.css"],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        organizations_service_1.OrganizationsService,
        core_1.ElementRef])
], UserListRowEditComponent);
//# sourceMappingURL=user-list-row-edit.component.js.map